import {Dispatch} from 'react'
import {COMPROBANTE_RETENCION_TYPES} from '../../constants/comprobanteRetencion.types'
import {State} from '../../reducers'
import {validacionEsRequerido} from '../../utils/validaciones'
import {comprobanteRetencionSetCatalogoSerie} from './comprobanteRetencionEmision.actions'
import { ComprobanteRetencionAction } from '../../interfaces/comprobante-retencion.interface'

// ******************************************************************************************
export const comprobanteRetencionFormSucursalHandleChange = (formSucursal: any) => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMSUCURSAL_HANDLE_CHANGE,
  payload: formSucursal,
})

export const comprobanteRetencionFormSucursalAddError = (error: any) => ({
  type: COMPROBANTE_RETENCION_TYPES.CRE_TYPE_FORMSUCURSAL_SET_ERRORS,
  payload: error,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const comprobanteRetencionFormSucursalHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<ComprobanteRetencionAction>) => {
    let {name, value} = e.target
    switch (name) {
      case 'sucursal':
        dispatch(comprobanteRetencionFormSucursalHandleChange({serie: ''}))
        break
      case 'serie':
        break
      default:
        break
    }
    dispatch(comprobanteRetencionFormSucursalHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const comprobanteRetencionFormSucursalOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => async (dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State) => {
  let {name, value} = e.target
  let message = ''
  switch (name) {
    case 'sucursal':
      message = validacionEsRequerido(value, message, 'Sucursal', 'requerida')
      let sucursal = getState().comprobanteRetencion.catalogoSucursal.find( (suc) => suc?.idsucursal === value )
      dispatch( comprobanteRetencionFormSucursalHandleChange({ datosSucursal: sucursal || null, serie: '', datosSerie: null, }) )
      dispatch(comprobanteRetencionSetCatalogoSerie(sucursal ? sucursal?.Documento : []))
      break
    case 'serie':
      message = validacionEsRequerido(value, message, 'Serie', 'requerida')
      let serie = getState().comprobanteRetencion.catalogoSerie.find((ser) => ser?.idsucursaldocumento === value )
      dispatch(comprobanteRetencionFormSucursalHandleChange({datosSerie: serie || null}))
      break
    default:
      break
  }
  dispatch(comprobanteRetencionFormSucursalAddError({[name]: message}))
}

export const comprobanteRetencionFormSucursalValidacion = ( dispatch: Dispatch<ComprobanteRetencionAction>, getState: () => State ) => {
  const {formSucursal, errorsFormSucursal} = getState().comprobanteRetencion
  // Validaciones
  errorsFormSucursal.sucursal = validacionEsRequerido( formSucursal.sucursal, errorsFormSucursal.sucursal,'Sucursal','requerida')
  errorsFormSucursal.serie = validacionEsRequerido( formSucursal.serie, errorsFormSucursal.serie, 'Serie', 'requerida' )
  
  dispatch(comprobanteRetencionFormSucursalAddError(errorsFormSucursal))
  if (errorsFormSucursal.sucursal || errorsFormSucursal.serie) return true
  return false
}
